var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useDebounce } from "use-debounce";
export var useSearchTrackForm = function () {
    var _a = React.useState(""), search = _a[0], setSearch = _a[1];
    var _b = React.useState([]), genres = _b[0], setGenres = _b[1];
    var _c = React.useState({ id: null }), client = _c[0], setClient = _c[1];
    var trackTitle = useDebounce(search, 1000)[0];
    var changeSearch = function (evt) {
        return setSearch(evt.target.value);
    };
    var changeClient = function (payload) {
        var _a;
        setClient(__assign(__assign({}, client), { id: (_a = payload === null || payload === void 0 ? void 0 : payload.id) !== null && _a !== void 0 ? _a : null }));
    };
    var changeGenres = function (payload) {
        setGenres(payload);
    };
    var form = { search: search, genres: genres };
    return {
        form: form,
        search: { value: search, onChange: changeSearch },
        genres: { value: genres, onChange: changeGenres },
    };
};
